var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 452,
    viewBox: "0 0 423 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.913 122.032H23.1445V211.426H410.913V122.032Z",
    fill: "#FF4500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.935 203.094H38.291V451.676H389.935V203.094Z",
    fill: "#FF4500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.003 59.3924C204.717 52.8354 162.006 10.1424 108.766 2.53673C67.7847 -3.3212 13.9725 2.53673 1.61179 47.8694C-10.7489 93.202 51.0667 122.07 104.644 122.07H210.201V60.2241L211.003 59.3924ZM44.7809 57.0661C107.115 38.0037 157.088 78.1594 157.088 78.1594C80.3262 85.3975 44.7809 57.5844 44.7809 57.0661Z",
    fill: "#4200FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M420.406 47.8452C408.04 2.51259 354.252 -3.34534 313.252 2.51259C260.013 10.1183 217.301 52.8112 211.016 59.3803C211.54 59.9287 211.811 60.224 211.811 60.224V122.058H317.374C370.952 122.058 432.773 93.1839 420.406 47.8452ZM264.918 78.1715C264.918 78.1715 314.891 37.9916 377.225 57.0781C377.237 57.5723 341.692 85.3854 264.93 78.1715H264.918Z",
    fill: "#4200FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.993 59.3818L210.191 60.2255V122.059H211.788V60.2135C211.788 60.2135 211.517 59.9182 210.993 59.3818Z",
    fill: "#4200FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M389.935 203.094H38.291V246.636H389.935V203.094Z",
    fill: "#FF4500"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.031 135.588C217.031 135.588 133.26 219.359 25.5452 259.249L41.5039 219.359L1.61328 207.39C129.264 167.499 193.093 83.7285 193.093 83.7285L217.031 135.588Z",
    fill: "#4200FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.828 134.397C197.828 134.397 284.377 220.946 395.654 262.162L379.189 220.946L420.405 208.585C288.524 167.369 222.58 80.8195 222.58 80.8195L197.828 134.397Z",
    fill: "#4200FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M249.812 133.296H182.838V451.673H249.812V133.296Z",
    fill: "#4200FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.33757ae9.svg";
export { ForwardRef as ReactComponent };